<template>
    <div class="store-upload-error">
        <div class="summary">
            <veui-span>总导入条数：{{ realData.totalNum }}</veui-span>
            <veui-span>导入成功数：{{ realData.updatedNum }}</veui-span>
            <veui-span>导入失败数：{{ realData.failedNum }}</veui-span>
        </div>
        <div class="error-wrap">
            <veui-table :data="tableData">
                <veui-table-column title="错误信息" field="errInfo">
                    <template slot-scope="props">
                        <p class="table-multi-line err-info">{{ props.errInfo }}</p>
                    </template>
                </veui-table-column>
                <veui-table-column v-for="name in headers"
                    :key="name"
                    :title="name"
                    :field="name">
                    <template slot-scope="props">
                        <p class="table-multi-line">{{ props[name] }}</p>
                    </template>
                </veui-table-column>
            </veui-table>
        </div>
        <div class="csv-wrap">
            <div>可将如下出错数据复制到CSV文件中，尝试重新上传（若经纬度有误，可到 <a
                class="map-doc-link" href="https://api.map.baidu.com/lbsapi/getpoint/index.html?c=" target="_blank">此处</a> 纠正）：</div>
            <veui-textarea :value="csvData" readonly/>
            <veui-button ui="aux small" class="copt-btn" v-copy:click="csvData">复制</veui-button>
        </div>
    </div>
</template>

<script>
import {Table, Span, Column, Textarea, Button} from 'veui';
import {get, zipObject, map} from 'lodash';
import copy from '@/common/directives/copy';

export default {
    name: 'StoreUploadError',
    components: {
        'veui-table': Table,
        'veui-span': Span,
        'veui-table-column': Column,
        'veui-textarea': Textarea,
        'veui-button': Button
    },
    props: {
        data: Object
    },
    directives: {
        copy: copy()
    },
    computed: {
        realData() {
            return this.data || {};
        },
        headers() {
            return get(this.realData, 'tableHeader', []);
        },
        failedPois() {
            return get(this.realData, 'failedPois', []);
        },
        csvData() {
            return this.headers.join(',')
            + '\n'
            + map(this.failedPois, item => item.poiLine.join(',')).join('\n');
        },
        tableData() {
            return this.failedPois.map(({errInfo, poiLine}) => {
                return {
                    errInfo,
                    ...zipObject(this.headers, poiLine)
                };
            });
        }
    }
};
</script>

<style lang="less">
@import "~@/common/css/lib.less";

.store-upload-error {

    .veui-table-cell {
        white-space: normal;
        word-break: break-all;
    }

    .summary {
        .veui-span+.veui-span {
            margin-left: 10px;
        }
    }
    .err-info {
        color: #f00;
    }
    .error-wrap {
        overflow: auto;
        .veui-table {
            width: 1500px;
        }
    }
    .csv-wrap {
        .map-doc-link {
            color: @veui-brand-color;
        }
        .veui-textarea {
            width: 800px;
            margin-top: 10px;
        }
        .copt-btn {
            margin: 0 0 4px 10px;
            vertical-align: bottom;
        }
    }
}
</style>
